export function getMaxStartIndex(flyObjectsLength, rules) {
    if (!rules?.flyObjectsCondition || flyObjectsLength <= 0) {
        return 0;
    }

    return Math.max(0, rules.startIndexCondition);
}

export function normalizeStartIndex(currentStartIndex, flyObjectsLength, rules) {
    const maxStartIndex = getMaxStartIndex(flyObjectsLength, rules);

    return Math.min(Math.max(0, currentStartIndex), maxStartIndex);
}
